import { createActions, createReducer } from 'reduxsauce'

import ConsultaOrdemCronologicaPagamentoService from '../../servicos/ConsultaOrdemCronologicaPagamentoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaOrdemCronologicaPagamentoInicio: [],
    buscaConsultaOrdemCronologicaPagamentoSucesso: ['consultaOrdemCronologicaPagamento'],
    buscaConsultaOrdemCronologicaPagamentoErro: ['erro'],
    setSelecionadoConsultaOrdemCronologicaPagamentoSucesso: ['selecionado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    selecionado: null,
    dataSincronizacaoDados: null,
}

// Ação para busca completa
Creators.buscaConsultaOrdemCronologicaPagamento = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConsultaOrdemCronologicaPagamentoInicio())
        let serv = new ConsultaOrdemCronologicaPagamentoService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaConsultaOrdemCronologicaPagamentoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaOrdemCronologicaPagamentoErro(error)))
    }
}

const buscaConsultaOrdemCronologicaPagamentoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaOrdemCronologicaPagamentoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaConsultaOrdemCronologicaPagamentoSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaOrdemCronologicaPagamento.resultado,
        dataSincronizacaoDados: action.consultaOrdemCronologicaPagamento.dataSincronizacaoDados,
        carregando: false,
    }
}

const setSelecionadoConsultaOrdemCronologicaPagamentoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, selecionado: action.selecionado, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_INICIO]: buscaConsultaOrdemCronologicaPagamentoInicio,
    [Types.BUSCA_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_ERRO]: buscaConsultaOrdemCronologicaPagamentoErro,
    [Types.BUSCA_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_SUCESSO]: buscaConsultaOrdemCronologicaPagamentoSucesso,
    [Types.SET_SELECIONADO_CONSULTA_ORDEM_CRONOLOGICA_PAGAMENTO_SUCESSO]: setSelecionadoConsultaOrdemCronologicaPagamentoSucesso,
})
